import { API, Auth } from 'aws-amplify';

export const getPresenceToken = (body) =>
{
	body.product = 'INLYNK';

	return API.post('presenceManagement', '/customTokenGeneration', { body });
};

export function createDocumentAPI(body)
{
	body.product = 'INLYNK';

	return API.post('presenceManagement', '/createDocument', { body });
}

export function getSuggestionUsers(body)
{
	body.product = 'INLYNK';

	return API.get('presenceManagement', '/getcontacts', { body });
}

export function newSendMessageAPI(body)
{
	body.product = 'INLYNK';

	return API.post('presenceManagement', '/newSendNotification', { body });
}

export function getLinkPreview(body)
{
	body.product = 'INLYNK';

	return API.post('presenceManagement', '/getLinkPreview', { body });
}

export function deleteMediaInS3(body)
{
	body.product = 'INLYNK';

	return API.post('ssoUserManagement', '/deletecontent', { body });
}

export function deleteChatMessages(body)
{
	body.product = 'INLYNK';

	return API.post('presenceManagement', '/deleteChat', { body });
}

export const manageNotifications = async (body) =>
{
	body.product = 'INLYNK';

	return API.post('presenceManagement', '/manageNotifications', { body });
};

export function generatePresignedUrl(body)
{
	body.product = 'INLYNK';

	return API.post('ssoUserManagement', '/generatepresignedurl', { body });
}

export async function broadcastEmployeeAccess(body)
{
	const session = await Auth.currentSession();
	const accessToken = session?.getIdToken()?.getJwtToken();

	body.product = 'INLYNK';

	// Send Firebase token in headers instead of body
	return API.post('folderManagement', '/broadcastV2', {
		body,
		headers : {
			'x-firebase-token' : accessToken
		}
	});
}

export function getCollaboration(queryStringParameters)
{
	return API.get('userManagement', '/configurations/collaboration', { queryStringParameters });
}

export function postCollabDisableEnable(body)
{
	body.product = 'INLYNK';

	return API.post('userManagement', '/configurations', { body });
}

export function postManageAccessAdmin(body)
{
	body.product = 'INLYNK';

	return API.post('userManagement', '/configurations', { body });
}

export function putManageAccessUsers(body)
{
	body.product = 'INLYNK';

	return API.put('userManagement', '/employeeUpdate', { body });
}

export function getCollaborationUsers(queryStringParameters)
{
	return API.get('userManagement', '/configurations/collaboration', { queryStringParameters });
}

export function postCollaborationUsers(body)
{
	body.product = 'INLYNK';

	return API.post('userManagement', '/configurations', { body });
}

export function BroadCastMessage(body)
{
	body.product = 'INLYNK';

	return API.post('presenceManagement', '/broadcastMessage', { body });
}

export function putAddEmployees(body)
{
	body.product = 'INLYNK';

	return API.put('userManagement', '/employeeUpdate', { body });
}

export const updateCallDetailsAPI = async (body) =>
{
	body.product = 'INLYNK';

	return API.post('presenceManagement', '/updateCallDetails', { body });
};

export const updatePresenceStatus = async (body) =>
{
	body.product = 'INLYNK';

	return API.post('presenceManagement', '/individualCallUpdate', { body });
};

export const declineGroupCallAPI = async (body) =>
{
	body.product = 'INLYNK';

	return API.post('presenceManagement', '/declineGroupCall', { body });
};

export const adminAndRMs = async (companyId) =>
{
	return API.get('userManagement', `/networkMembers/${companyId}`, {});
};
